import { useGlobalContext } from "./Context"
import SearchBox from "./Components/SearchBox";
import LoadingIcon from "./Components/LoadingIcon";
import PremisesList from "./Components/PremisesList";
import { Alert, Typography, Col, Row } from 'antd';

const Search = () => {
    const { premisesList, loading } = useGlobalContext();
    const { searchKeyword } = useGlobalContext();

    if (loading) {
        return (
            <Row>
                <Col span={24}>
                    <div className="row d-flex justify-content-center align-items-center">
                        <LoadingIcon />
                    </div>
                </Col>
            </Row>

        )
    }

    return (
        <>
            <Row>
                <Col span={24}>
                    <SearchBox />
                </Col>
            </Row>
            <Row style={{marginTop: "10px"}}>
                <Col span={24}>
                    <Typography.Title level={3}>You have searched "{searchKeyword}"</Typography.Title>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    {(premisesList.length >= 20) &&
                        <Alert
                            message="The search only returns top 20 results."
                            type="warning"
                        />
                    }
                </Col>
            </Row>            
            <Row>
                <Col span={24}>
                    <PremisesList premises={premisesList} isFromSearch={true} />
                </Col>
            </Row>
        </>
    );
}

export default Search;
